import { useEffect, useState, useCallback } from "react";

function useApi({
  callback = () => {},
  dependencies = [],
  payload = "",
  shouldCallApi = true,
  onSuccess = () => {},
  onError = () => {},
}) {
  const [data, setData] = useState({
    error: false,
    data: [],
    loading: null,
    catch: null,
  });

  // const memoizedCallback = useCallback(callback, [callback]);

  // useEffect(() => {
  //   if (!memoizedCallback || !shouldCallApi) return;
  //   const fetchData = async () => {
  //     setData((pre) => ({ ...pre, loading: true }));
  //     try {
  //       const reqPayload = Array.isArray(payload) ? payload : [payload];
  //       const res = await memoizedCallback(...reqPayload);
  //       setData({ error: false, data: res, loading: false, catch: null });
  //       if (res.data && onSuccess) {
  //         onSuccess(res.data);
  //       }
  //     } catch (error) {
  //       console.error(error);
  //       if (onError) onError(error.response.data.message);
  //       setData({ error: true, data: [], loading: false, catch: error });
  //     }
  //   };

  //   fetchData();
  // }, [memoizedCallback, shouldCallApi, ...dependencies]);

  return data;
}

export default useApi;
